import BaseModel from "./BaseModel";

// import {
//   canEdit,
//   canView,
//   canDelete,
//   isClosed,
//   isCompliant,
//   simpleStatus,
//   canOpen,
//   canClose,
//   isOwner,
//   isApproved,
//   canUploadProgramme,
//   isEvaluated
// } from "@/helpers/Certification";

class ReportModel extends BaseModel {
  id: number = 0;
  parent: number = 0;
  report: number = 0;
  year: number = 0;
  status: string = "";
  type: string = "";
  organization: string = "";

  hcpIndAmount: number = 0;
  hcpIndRegCost: number = 0;
  hcpIndTravelCost: number = 0;
  hcpIndBasicSalary: number = 0;
  hcpIndAdditionalSalary: number = 0;

  hcpGrpAmount: number = 0;
  hcpGrpRegCost: number = 0;
  hcpGrpTravelCost: number = 0;
  hcpGrpBasicSalary: number = 0;
  hcpGrpAdditionalSalary: number = 0;

  hcoIndAmount: number = 0;
  hcoIndDonation: number = 0;
  hcoIndRegCost: number = 0;
  hcoIndTravelCost: number = 0;
  hcoIndSponsorship: number = 0;
  hcoIndBasicSalary: number = 0;
  hcoIndAdditionalSalary: number = 0;

  hcoGrpAmount: number = 0;
  hcoGrpDonation: number = 0;
  hcoGrpRegCost: number = 0;
  hcoGrpTravelCost: number = 0;
  hcoGrpSponsorship: number = 0;
  hcoGrpBasicSalary: number = 0;
  hcoGrpAdditionalSalary: number = 0;

  rndCost: number = 0;

  reportUrl: string = "";
  organizationReportUrl: string = "";
  organizationComments: string = "";
  approverComments: string = "";

  extended: object = {};
  createdBy: number = 0;
  createdOn: Date | null = null;
  approved: boolean = false;
  approvedBy: number = 0;
  approvedOn: Date | null = null;
  published: boolean = false;
  publishedBy: number = 0;
  publishedOn: Date | null = null;
  deleted: number = 0;
  deletedBy: number = 0;
  deletedOn: Date | null = null;

  draft: boolean = false;

  constructor(options?: object) {
    super(options);
    this.setData(options);
  }

  get hcpAmount() {
    return this.sumColsByNames(["hcpIndAmount", "hcpGrpAmount"]);
  }

  get hcpIndEventTotal() {
    return this.sumColsByNames(["hcpIndRegCost", "hcpIndTravelCost"]);
  }

  get hcpGrpEventTotal() {
    return this.sumColsByNames(["hcpGrpRegCost", "hcpGrpTravelCost"]);
  }

  get hcpRegTotal() {
    return this.sumColsByNames(["hcpIndRegCost", "hcpGrpRegCost"]);
  }

  get hcpTravelTotal() {
    return this.sumColsByNames(["hcpIndTravelCost", "hcpGrpTravelCost"]);
  }

  get hcpEventTotal() {
    return this.sumColsByNames(["hcpRegTotal", "hcpTravelTotal"]);
  }

  get hcpIndSalaryTotal() {
    return this.sumColsByNames(["hcpIndBasicSalary", "hcpIndAdditionalSalary"]);
  }

  get hcpGrpSalaryTotal() {
    return this.sumColsByNames(["hcpGrpBasicSalary", "hcpGrpAdditionalSalary"]);
  }

  get hcpBasicSalaryTotal() {
    return this.sumColsByNames(["hcpIndBasicSalary", "hcpGrpBasicSalary"]);
  }

  get hcpAdditionalSalaryTotal() {
    return this.sumColsByNames([
      "hcpIndAdditionalSalary",
      "hcpGrpAdditionalSalary"
    ]);
  }

  get hcpSalaryTotal() {
    return this.sumColsByNames([
      "hcpBasicSalaryTotal",
      "hcpAdditionalSalaryTotal"
    ]);
  }

  get hcpIndTotal() {
    return this.sumColsByNames(["hcpIndEventTotal", "hcpIndSalaryTotal"]);
  }

  get hcpGrpTotal() {
    return this.sumColsByNames(["hcpGrpEventTotal", "hcpGrpSalaryTotal"]);
  }

  get hcpTotal() {
    return this.sumColsByNames(["hcpIndTotal", "hcpGrpTotal"]);
  }

  get hcpAverage() {
    return this.hcpTotal / this.hcpAmount;
  }

  get hcpIndAverage() {
    return this.hcpIndTotal / this.hcpIndAmount;
  }

  get hcpGrpAverage() {
    return this.hcpGrpTotal / this.hcpGrpAmount;
  }

  get hcoAmount() {
    return this.sumColsByNames(["hcoIndAmount", "hcoGrpAmount"]);
  }

  get hcoIndDonationTotal() {
    return this.hcoIndDonation;
  }

  get hcoGrpDonationTotal() {
    return this.hcoGrpDonation;
  }

  get hcoDonationTotal() {
    return this.sumColsByNames(["hcoIndDonationTotal", "hcoGrpDonationTotal"]);
  }

  get hcoIndEventTotal() {
    return this.sumColsByNames([
      "hcoIndRegCost",
      "hcoIndTravelCost",
      "hcoIndSponsorship"
    ]);
  }

  get hcoGrpEventTotal() {
    return this.sumColsByNames([
      "hcoGrpRegCost",
      "hcoGrpTravelCost",
      "hcoGrpSponsorship"
    ]);
  }

  get hcoRegTotal() {
    return this.sumColsByNames(["hcoIndRegCost", "hcoGrpRegCost"]);
  }

  get hcoTravelTotal() {
    return this.sumColsByNames(["hcoIndTravelCost", "hcoGrpTravelCost"]);
  }

  get hcoSponsorshipTotal() {
    return this.sumColsByNames(["hcoIndSponsorship", "hcoGrpSponsorship"]);
  }

  get hcoEventTotal() {
    return this.sumColsByNames([
      "hcoRegTotal",
      "hcoTravelTotal",
      "hcoSponsorshipTotal"
    ]);
  }

  get hcoIndSalaryTotal() {
    return this.sumColsByNames(["hcoIndBasicSalary", "hcoIndAdditionalSalary"]);
  }

  get hcoGrpSalaryTotal() {
    return this.sumColsByNames(["hcoGrpBasicSalary", "hcoGrpAdditionalSalary"]);
  }

  get hcoBasicSalaryTotal() {
    return this.sumColsByNames(["hcoIndBasicSalary", "hcoGrpBasicSalary"]);
  }

  get hcoAdditionalSalaryTotal() {
    return this.sumColsByNames([
      "hcoIndAdditionalSalary",
      "hcoGrpAdditionalSalary"
    ]);
  }

  get hcoSalaryTotal() {
    return this.sumColsByNames([
      "hcoBasicSalaryTotal",
      "hcoAdditionalSalaryTotal"
    ]);
  }

  get hcoIndTotal() {
    return this.sumColsByNames([
      "hcoIndDonationTotal",
      "hcoIndEventTotal",
      "hcoIndSalaryTotal"
    ]);
  }

  get hcoGrpTotal() {
    return this.sumColsByNames([
      "hcoGrpDonationTotal",
      "hcoGrpEventTotal",
      "hcoGrpSalaryTotal"
    ]);
  }

  get hcoTotal() {
    return this.sumColsByNames(["hcoIndTotal", "hcoGrpTotal"]);
  }

  get hcoAverage() {
    return this.hcoTotal / this.hcoAmount;
  }

  get hcoIndAverage() {
    return this.hcoIndTotal / this.hcoIndAmount;
  }

  get hcoGrpAverage() {
    return this.hcoGrpTotal / this.hcoGrpAmount;
  }

  get rndTotal() {
    return this.rndCost;
  }

  get total() {
    return this.sumColsByNames(["hcoTotal", "hcpTotal", "rndTotal"]);
  }

  get hcoSalaryPercent() {
    return this.hcoTotal > 0 ? this.hcoSalaryTotal / this.hcoTotal : 0;
  }

  get hcoEventPercent() {
    return this.hcoTotal > 0 ? this.hcoEventTotal / this.hcoTotal : 0;
  }

  get hcoDonationPercent() {
    return this.hcoTotal > 0 ? this.hcoDonationTotal / this.hcoTotal : 0;
  }

  get hcoPercent() {
    return this.total > 0 ? this.hcoTotal / this.total : 0;
  }

  get hcoIndPercent() {
    return this.hcoTotal > 0 ? this.hcoIndTotal / this.hcoTotal : 0;
  }

  get hcoGrpPercent() {
    return this.hcoTotal > 0 ? this.hcoGrpTotal / this.hcoTotal : 0;
  }

  get hcoIndAmountPercent() {
    return this.hcoAmount > 0 ? this.hcoIndAmount / this.hcoAmount : 0;
  }

  get hcoGrpAmountPercent() {
    return this.hcoAmount > 0 ? this.hcoGrpAmount / this.hcoAmount : 0;
  }

  get hcpEventPercent() {
    return this.hcpTotal > 0 ? this.hcpEventTotal / this.hcpTotal : 0;
  }

  get hcpSalaryPercent() {
    return this.hcpTotal > 0 ? this.hcpSalaryTotal / this.hcpTotal : 0;
  }

  get hcpPercent() {
    return this.total > 0 ? this.hcpTotal / this.total : 0;
  }

  get hcpIndPercent() {
    return this.hcpTotal > 0 ? this.hcpIndTotal / this.hcpTotal : 0;
  }

  get hcpGrpPercent() {
    return this.hcpTotal > 0 ? this.hcpGrpTotal / this.hcpTotal : 0;
  }

  get hcpIndAmountPercent() {
    return this.hcpAmount > 0 ? this.hcpIndAmount / this.hcpAmount : 0;
  }

  get hcpGrpAmountPercent() {
    return this.hcpAmount > 0 ? this.hcpGrpAmount / this.hcpAmount : 0;
  }

  get rndPercent() {
    return this.total > 0 ? this.rndTotal / this.total : 0;
  }

  sumColsByNames(names: string[]) {
    let sum: number = 0;
    names.forEach((name: string) => {
      sum = sum + (this as any)[name];
    });
    return sum;
  }

  // sumColsByNames(names: string[], exclude: string[] = []): number {
  //   let cols = Object.getOwnPropertyNames(this);
  //   let sum = 0;
  //   cols = cols.filter(colName => {
  //     return (
  //       names.filter((partialName: string) =>
  //         colName.match(new RegExp(`${partialName}`))
  //       ).length === names.length
  //     );
  //   });
  //   cols = cols.filter(colName => {
  //     return !exclude.includes(colName);
  //   });
  //   cols.forEach((colName: any) => (sum += (this as any)[colName] || 0));
  //   return sum;
  // }

  // isOwner(user) {
  //   return isOwner(this, user);
  // }

  // canEdit(user) {
  //   return canEdit(this, user);
  // }

  // canView(user) {
  //   return canView(this, user);
  // }

  // canDelete(user) {
  //   return canDelete(this, user);
  // }

  // isClosed() {
  //   return isClosed(this);
  // }

  // isEvaluated() {
  //   return isEvaluated(this);
  // }

  // isApproved() {
  //   return isApproved(this);
  // }

  // canOpen(user) {
  //   return canOpen(this, user);
  // }

  // canClose(user) {
  //   return canClose(this, user);
  // }
}

export default ReportModel;

/*

get hcpRegCost(): number {
    return this.sumColsByNames(["hcp", "RegCost"]);
  }

  get hcpTravelCost(): number {
    return this.sumColsByNames(["hcp", "TravelCost"]);
  }

  get hcpBasicSalary(): number {
    return this.sumColsByNames(["hcp", "BasicSalary"]);
  }

  get hcpAdditionalSalary(): number {
    return this.sumColsByNames(["hcp", "AdditionalSalary"]);
  }

  get hcpIndTotal(): number {
    return this.sumColsByNames(["hcpInd"], ["hcpIndAmount"]);
  }

  get hcpGrpTotal(): number {
    return this.sumColsByNames(["hcpGrp"], ["hcpGrpAmount"]);
  }

  get hcpEventCost(): number {
    return this.hcpRegCost + this.hcpTravelCost;
  }

  get hcpSalaryCost(): number {
    return this.hcpBasicSalary + this.hcpAdditionalSalary;
  }

  get hcpTotal(): number {
    return this.hcpEventCost + this.hcpSalaryCost;
  }

  get hcoDonation(): number {
    return this.sumColsByNames(["hco", "Donation"]);
  }

  get hcoRegCost(): number {
    return this.sumColsByNames(["hco", "RegCost"]);
  }

  get hcoTravelCost(): number {
    return this.sumColsByNames(["hco", "TravelCost"]);
  }

  get hcoSponsorship(): number {
    return this.sumColsByNames(["hco", "Sponsorship"]);
  }

  get hcoBasicSalary(): number {
    return this.sumColsByNames(["hco", "BasicSalary"]);
  }

  get hcoAdditionalSalary(): number {
    return this.sumColsByNames(["hco", "AdditionalSalary"]);
  }

  get hcoIndTotal(): number {
    return this.sumColsByNames(["hcoInd"], ["hcoIndAmount"]);
  }

  get hcoGrpTotal(): number {
    return this.sumColsByNames(["hcoGrp"], ["hcoGrpAmount"]);
  }

  get hcoEventCost(): number {
    return this.hcoRegCost + this.hcoTravelCost + this.hcoSponsorship;
  }

  get hcoSalaryCost(): number {
    return this.hcoBasicSalary + this.hcoAdditionalSalary;
  }

  get hcoTotal(): number {
    return this.hcoDonation + this.hcoEventCost + this.hcoSalaryCost;
  }

  */
